import { render, staticRenderFns } from "./f-title.vue?vue&type=template&id=51c32374&lang=pug&"
import script from "./f-title.vue?vue&type=script&lang=js&"
export * from "./f-title.vue?vue&type=script&lang=js&"
import style0 from "./f-title.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c32374')) {
      api.createRecord('51c32374', component.options)
    } else {
      api.reload('51c32374', component.options)
    }
    module.hot.accept("./f-title.vue?vue&type=template&id=51c32374&lang=pug&", function () {
      api.rerender('51c32374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-title.vue"
export default component.exports